export default __webpack_public_path__ + "static/media/3.2ada38ae.jpg";